'use client';
export const dynamic = 'force-dynamic';
import { BaseComp } from 'components';
import Error500Comp from 'mrCity/500/500.index';
import { __MetaTags } from './_lib/metatags';
export const metadata = __MetaTags({ title: 'آقای شهر | درخواست با خطا مواجه شد' });

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <BaseComp showHeaderInMobile>
            <Error500Comp error={error} reset={reset} />
        </BaseComp>
    );
}
